export default __webpack_public_path__ + "static/Background-176c6592566d9ab0b8f472274feb13e5.jpg";